import { Grid, Paper, TableCell, TableRow, Typography } from "@material-ui/core"
import { InputReactDatepicker, MasterButton } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { TYPE_INSTANCEVCLAIM } from "App/constants"
import { useDatatables } from "App/hooks"
import { fetchDataPost, today } from "App/utils/helpers"
import { FreezeTableClient, LoadingTableSkeleton } from "components/organism"
import React, { Fragment, useEffect, useState } from "react"

const ListRujukanKhusus = ({ showListRujukanKhusus }) => {
  const [formFilter, setFormFilter] = useState({ waktu: new Date() })
  const [rowsRujukanKhusus, setRowsRujukanKhusus] = useState([])
  const [loadingRujukanKhusus, setLoadingRujukanKhusus] = useState(false)
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rowsRujukanKhusus ?? [],
    orderByDefault: "nmpst",
    orderByRow: ["nmpst", "diagppk", "norujukan", "idrujukan", "nokapst"],
  })

  const setNewData = async () => {
    try {
      setLoadingRujukanKhusus(true)
      const bulan = Number(formFilter.waktu.getMonth()) + 1
      const tahun = formFilter.waktu.getFullYear()?.toString()

      const re = await fetchDataPost(
        TYPE_INSTANCEVCLAIM,
        "/api/v1/emr/bridging/rujukan/list-rujukan-khusus",
        "response",
        {
          bulan: bulan?.toString().padStart(2, "0"),
          tahun,
        },
        {},
        "rujukan",
      )
      setRowsRujukanKhusus(re || [])
    } catch (error) {
      setRowsRujukanKhusus([])
      console.log("ERROR FETCH RUJUKAN KHUSUS" + error)
    } finally {
      setLoadingRujukanKhusus(false)
    }
  }
  useEffect(() => {
    setNewData()
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()
    setNewData()
  }

  return (
    <Fragment>
      <form onSubmit={onSubmit}>
        <Paper style={{ marginBottom: "10px", padding: "10px 14px 0px 14px" }}>
          <Typography
            style={{
              fontSize: "14px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
            variant="h6"
            component="div"
          >
            Filter Rujukan Khusus
          </Typography>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <Grid item sm={12}>
                <InputReactDatepicker
                  selected={formFilter.waktu}
                  showMonthYearPicker
                  label={"Tanggal"}
                  dateFormat="MM/yyyy"
                  onChange={(e) => {
                    setFormFilter({
                      ...formFilter,
                      waktu: e,
                    })
                  }}
                  handleChangeToday={(e) => {
                    setFormFilter({
                      ...formFilter,
                      waktu: new Date(e),
                    })
                  }}
                />
              </Grid>
            </Grid>
            <Grid item sm={12} style={{ marginBottom: "10px" }}>
              <Grid container justifyContent="flex-end">
                <MasterButton type="submit" name="Cari" />
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </form>
      <FreezeTableClient
        title="Daftar Rujukan Khusus"
        setQ={setQ}
        maxHeight="300px"
        withAddButton={false}
        isFreeze={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={data}
        withPadding
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {!loadingRujukanKhusus ? (
          stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow key={index}>
                  <TableCell width={"4%"} align="center">
                    {index + 1}
                  </TableCell>
                  <TableCell align="left">{row?.idrujukan}</TableCell>
                  <TableCell align="left">{row?.diagppk}</TableCell>
                  <TableCell align="left">{row?.nmpst}</TableCell>
                  <TableCell align="left">{row?.nokapst}</TableCell>
                  <TableCell align="left">{row?.norujukan}</TableCell>
                  <TableCell align="left">{row?.tglrujukan_awal}</TableCell>
                  <TableCell align="left">{row?.tglrujukan_berakhir}</TableCell>
                </TableRow>
              )
            })
        ) : (
          <LoadingTableSkeleton colSpan={7} />
        )}
      </FreezeTableClient>
    </Fragment>
  )
}

export default ListRujukanKhusus

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "idrujukan",
    disablePadding: false,
    label: "ID RUJUKAN",
    align: "left",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "diagppk",
    disablePadding: false,
    label: "DIAGPPK",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "nmpst",
    disablePadding: false,
    label: "NMPST",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "nokapst",
    disablePadding: false,
    label: "NO KAPST",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "norujukan",
    disablePadding: false,
    label: "NO RUJUKAN",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "tglawal",
    disablePadding: false,
    label: "TGL RUJUKAN AWAL",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
  {
    id: "tglakhir",
    disablePadding: false,
    label: "TGL RUJUKAN BERAKHIR",
    align: "left",
    minWidth: "120px",
    sort: false,
  },
]
